import React, { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { APP_FADE, MOTION_EASE, pageContentVariants } from '../utils/motion';

interface PageTransitionProps {
    children: ReactNode;
    className?: string;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children, className = "" }) => {
    const prefersReducedMotion = useReducedMotion();

    return (
        <div className={`relative w-full h-full ${className}`}>
            {!prefersReducedMotion && (
                <motion.div
                    aria-hidden="true"
                    initial={{ opacity: 0, y: -18 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 16 }}
                    transition={{ duration: 0.34, ease: MOTION_EASE }}
                    className="pointer-events-none absolute inset-x-0 top-0 z-0 h-28 bg-linear-to-b from-white/35 via-white/12 to-transparent dark:from-white/6 dark:via-white/[0.03] dark:to-transparent"
                />
            )}

            <motion.div
                variants={pageContentVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={prefersReducedMotion ? { duration: 0.14 } : APP_FADE}
                className="relative z-10 w-full h-full"
            >
                {children}
            </motion.div>
        </div>
    );
};
